import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useDatenadapterCredentials } from "@/hooks/useDatenadapterCredentials";
import { Loading } from "@/components/ui/loading";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function DatenadapterCredentialsInput() {
  const {
    username,
    password,
    apiUrl,
    isLoading,
    showPassword,
    handleUsernameChange,
    handlePasswordChange,
    handleApiUrlChange,
    togglePasswordVisibility,
    handleSaveCredentials,
  } = useDatenadapterCredentials();

  return (
    <div className="space-y-4">
      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="datenadapter-username">Benutzername</Label>
        </div>
        <Input
          id="datenadapter-username"
          type="text"
          value={username}
          onChange={handleUsernameChange}
          disabled={isLoading}
          placeholder="z.B. avatarki"
        />
      </ControlWrapper>

      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="datenadapter-password">Passwort</Label>
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSaveCredentials();
          }}
        >
          <div className="flex gap-2">
            <Input
              id="datenadapter-password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              disabled={isLoading}
              placeholder="API Passwort"
              className="flex-1"
            />
            <Button
              type="button"
              onClick={togglePasswordVisibility}
              variant="ghost"
              size="icon"
              disabled={isLoading}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </Button>
          </div>
        </form>
        {isLoading && <Loading />}
      </ControlWrapper>

      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="datenadapter-api-url">API Base URL (optional)</Label>
        </div>
        <Input
          id="datenadapter-api-url"
          type="text"
          value={apiUrl}
          onChange={handleApiUrlChange}
          disabled={isLoading}
          placeholder="https://your-api-endpoint.example.com/daten"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Base URL mit /daten, aber ohne Endpoint-Pfad (z.B. ohne /oasis/api/v1)
        </p>
      </ControlWrapper>
    </div>
  );
}
